import { IPurchased } from './interfaces';
import { get } from '../../../DAL/data-provider';

const SESSION_STORAGE_KEY = 'purchased';

/**
 * clear session storage
 */
export const clearUserPurchasedData = () => {
    window.sessionStorage.removeItem(SESSION_STORAGE_KEY);
};

/**
 * https://jira.waves.com:8443/browse/WAV-1228
 */
export const getUserPurchasedData = async () : Promise<IPurchased|null> => {

    /* [{
        "skuNumber": "TBS10",
        "contentType": 1
    }, {
        "skuNumber": "V5-ATD40",
        "contentType": 1
    }, {
        "skuNumber": "V5-C1D40",
        "contentType": 1
    }]
    */
    const res = await get('/api/userpurchaseddata/get-data');
    return res ? res.data : null;
};

/**
 * try to get data from the session storage
 * if the data is empty -> perform ajax request
 */
export const getPurchasedData = async () : Promise<IPurchased|null> => {

    if(!window.sessionStorage) return null;

    let dataStr = window.sessionStorage.getItem(SESSION_STORAGE_KEY);
    let data: IPurchased|null = null;

    try{
        data = JSON.parse(dataStr || '');
    }
    catch(ex){}

    /*if(data &&
        data.purchasedProducts &&
        data.purchasedProducts.length > 0 &&
        data.recommendedProducts &&
        data.recommendedProducts.length > 0) return data;*/

    if(!!data?.purchasedProducts && !!data?.recommendedProducts) return data;

    // if no data -> perform ajax request
    data = await getUserPurchasedData();

    window.sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(data));

    return data;
};

/**
 * if session storage is empty -> get data from server and update session storage
 * @return {Promise<void>}
 */
export const updateSessionStorage = async () => {

    if(!window.sessionStorage) return;

    // thank you page -> empty session storage first
    if(window.location.href.indexOf('/cart/thank-you') !== -1 ||
        window.location.href.indexOf('/inapp/cart/thank-you') !== -1){
        clearUserPurchasedData();
    }
    else{
        // if not thank you page and there is an item -> keep it till the end of the session
        let valueStr = window.sessionStorage.getItem(SESSION_STORAGE_KEY);
        let value: IPurchased|null = null;
        try{
            value = JSON.parse(valueStr || '');
        }
        catch(ex){}

        // if(value && value.length > 0) return;

        if(value &&
            value.purchasedProducts &&
            value.purchasedProducts.length > 0 &&
            value.recommendedProducts &&
            value.recommendedProducts.length > 0) return;
    }

    // if session storage is empty try to get updated data from the server

    /*
    [{
        "skuNumber": "TBS10",
        "contentType": 1
    }, {
        "skuNumber": "V5-ATD40",
        "contentType": 1
    }, {
        "skuNumber": "V5-C1D40",
        "contentType": 1
    }]
    */

    // 1 = I own this product
    // 2 = I own a bundle containing this product
    const data = await getUserPurchasedData();

    window.sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(data));
};

/**
 * reset and reload user purchased products
 * for example, after successful login
 */
export const updateUserPurchasedData = async () => {

    // clear the storage
    clearUserPurchasedData();

    // bring new data from server side
    const data = await getUserPurchasedData();

    // update the storage
    window.sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(data));

    return data;
};
